module.exports = __webpack_public_path__ + "static/media/pplogo-192-capital.6cbdffbe.png";